define('app/views/overlay_view',['app/setup'], function(takhfifan) {

  takhfifan.OverlayView = Backbone.View.extend({

    events: {
      'click': 'triggerBlur'
    },

    triggerBlur: function() {
      takhfifan.eventHub.trigger('overlay:blur');
      this.$el.fadeOut();
    }
  });
});

